<template>
  <div class="progessView">
    <div class="vowView">
      <span class="vowText">{{helpwish}}</span>
    </div>
    <div class="progressView">
      <div class="progress">
        <van-progress stroke-width="8px" color="linear-gradient(to right, #FED420, #FEB71B)" class="progessOne" pivot-text :percentage="total1" />
        <van-progress stroke-width="8px" color="linear-gradient(to right, #FEB71B, #FE8014)" class="progessTwo" pivot-text :percentage="total2" />
        <van-progress stroke-width="8px" color="linear-gradient(to right, #FE8014, #FF3C09)" class="progessThree" pivot-text :percentage="total3" />
        <van-progress stroke-width="8px" color="linear-gradient(to right, #FF3C09, #FF0B01)" class="progessFour" pivot-text :percentage="total4" />
      </div>
      <div class="gifts">
        <img class="gift4" src="../../static/images/gift4.png" alt />
        <img class="gift" src="../../static/images/gift.png" alt />
        <img class="gift2" src="../../static/images/gift2.png" alt />
        <img class="gift3" src="../../static/images/gift3.png" alt />
      </div>
      <!-- v-if="helpnum >= 5"第一名用户 -->
      <div v-if="maxUser" @click="goRank" class="moreView flex-column">
        <!-- <p class="morePrize">更多奖励</p> -->
        <img src="../../static/images/icon_one.png" class="moreView-img01" alt="">
        <img v-if="maxUser.avatar" :src="maxUser.avatar" class="moreView-img02" alt="">
        <img v-else src="../../static/images/avatar.png" class="moreView-img02" alt="">
        <div class="text-center moreView-num">{{maxUser.help_num}}人祝福</div>
      </div>
      <div class="giftNum">
        <!-- <p class="giftNumText giftText">0</p>
        <p class="giftNumText giftText1">5</p>
        <p class="giftNumText giftText1">10</p>
        <p class="giftNumText giftText1">15</p> -->
        <p class="giftNumText giftText">许愿成功</p>
        <p class="giftNumText giftText1">3人祝福</p>
        <p class="giftNumText giftText1">6人祝福</p>
        <p class="giftNumText giftText1">9人祝福</p>
      </div>
    </div>
    <div class="helpText">
      <p class="helpTotal">已获得祝福{{helpnum}}人</p>
    </div>
    <div class="userPics">
      <template v-for="(i, index) in helplist ">
        <img v-if="index <4" class="userPic" v-bind:src="i.avatar" alt :key="index" />
      </template>
      <img v-if="helpnum>=5" @click="showMoreModal('friend')" class="userPic2" src="../../static/images/more_btn.png" alt />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Progress } from "vant";

Vue.use(Progress);
export default {
  name: "CommProgress",
  props: ["helplist", "helpnum", "helpwish", "maxUser"],
  data() {
    return {
      downapp: true,
      total1: 0,
      total2: 0,
      total3: 0,
      total4: 0
    };
  },
  methods: {
    //展示好友弹窗
    showMoreModal(status) {
      //此处用 this.$emit 无法触发父组件的函数。不懂为啥。。
      //   let _this = this;
      //   _this.$options.parent.commOpenModal(status);
      this.$emit("showFriend", status);
    },
        // 去排行榜
    goRank() {
      var t = this;
      t.$router.push({
        path: "/ranklist",
        query: {}
      });
    },
  },

  mounted() {
    let total = this.helpnum; //祝福人数
    if (total < 3) {
      this.total1 = Math.round((total -0 )/ 3 * 100); //计算第一阶段进度条
    }
    if (total > 3 && total <= 6) {
      this.total1 = 100; //计算第一阶段进度条
      this.total2 = Math.round((total - 3) / 3 * 100); //计算第二阶段进度条
    }
    if (total > 6 && total <= 9) {
      this.total1 = 100; //计算第一阶段进度条
      this.total2 = 100; //计算第二阶段进度条
      this.total3 = Math.round((total - 6) / 3 * 100); //计算第三阶段进度条
    }
    if (total > 9) {
      this.total1 = 100; //计算第一阶段进度条
      this.total2 = 100; //计算第二阶段进度条
      this.total3 = 100; //计算第三阶段进度条
      //【是否需要设置最大刻度？？默认 41 即总刻度为 41+9 】
      this.total4 = Math.round((total-9) / 41 * 100); //计算第四阶段进度条
    }
  }
};
</script>

<style scoped lang="scss" src="../../static/scss/helpme.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>

